// REACT IMPORTS
import React from "react";

// COMPONENT IMPORTS
import SidePanel from "components/auth/SidePanel";
import SignUpForm from "components/auth/SignUpForm";
import QuestionsFooter from "components/auth/QuestionsFooter";
import Helment from "components/layout/helmet";
import { TestIdScope } from "utils/testid";

/* ------------------------------------- SIGN UP PAGE ------------------------------------- */

const SignUp = () => {
  return (
    <>
      <Helment />
      <TestIdScope scope="auth-sign-up">
        <div
          data-testid="auth-sign-up-page"
          className="lg:overflow-y-none overflow-y-auto portal-shell h-[var(--shell-vh)] flex lg:justify-center relative animate__animated animate__fadeIn lg:flex-row flex-col"
        >
          <div className="lg:w-2/5 w-full">
            <SidePanel />
          </div>
          <div className="lg:w-3/5 w-full h-full flex flex-col items-center justify-between lg:overflow-y-auto">
            <div className="lg:pt-[134px] p-5 w-full flex justify-center">
              <SignUpForm />
            </div>
            <div className={`pb-5 lg:pt-0 pt-4`}>
              <QuestionsFooter />
            </div>
          </div>
        </div>
      </TestIdScope>
    </>
  );
};

export default SignUp;
